import React, {useEffect, useState} from "react";
import {getCompanies, getCompaniesDetailsAsync} from "./companies-service";
import {isNotEmptyArray, showlog} from "../../utils";
import moment from "moment";
import {DATETIME_FORMAT_IT} from "../../conf";

export function CompaniesPage() {

	type CompanyDetails = { latestOrderTime: number, operators: string[], documentNumber: string }
	type Company = { name: string } & CompanyDetails
	type SortDirection = 'ascending' | 'descending';
	type SortableKeys = 'latestOrderTime' | 'operators';

	const [companyList, setCompanyList] = useState<Company[]>([])
	const [sortConfig, setSortConfig] = useState<{ key: SortableKeys, direction: SortDirection } | null>(null);
	const [expandedRows, setExpandedRows] = useState<number[]>([]);
	useEffect(() => {
		getCompanyList()
	}, []);

	async function getCompanyList() {
		try {
			const companies = await getCompanies() || []

			if (isNotEmptyArray(companies?.data)) {

				const companiesNames = companies.data.map((company: any) => ({name: company}))
				setCompanyList(companiesNames);
				await getCompanyDetails(companies.data)
			}
		} catch (e) {
			showlog("error in getCompanyList()", e);
		}
	}

	async function getCompanyDetails(companiesNames: string[]) {
		try {
			const companiesDetails: CompanyDetails[][] = (await getCompaniesDetailsAsync(companiesNames))?.data || []

			setCompanyList(currentCompanyList => {
				const companyListCopy = [...currentCompanyList];
				companiesDetails.forEach((companyDetailsArray, index) => {
					const details = companyDetailsArray[0];
					if (details && (details.latestOrderTime || details.operators)) {
						companyListCopy[index] = { ...companyListCopy[index], ...details };
					}
				});
				return companyListCopy;
			});
		} catch (e) {
			showlog("error in getCompanyDetails()", e);
		}
	}

	function requestSort(key: SortableKeys) {
		let direction: SortDirection = 'descending';
		if (sortConfig && sortConfig.key === key && sortConfig.direction === 'descending') {
			direction = 'ascending';
		}
		setSortConfig({ key, direction });

		const sortedList = [...companyList].sort((a, b) => {
			let aValue, bValue;

			if (key === 'operators') {
				aValue = a.operators?.length || 0;
				bValue = b.operators?.length || 0;
			} else { // latestOrderTime
				aValue = a.latestOrderTime || 0;
				bValue = b.latestOrderTime || 0;
			}

			if (aValue < bValue) {
				return direction === 'ascending' ? -1 : 1;
			}
			if (aValue > bValue) {
				return direction === 'ascending' ? 1 : -1;
			}
			return 0;
		});
		setCompanyList(sortedList);
	}

	const renderSortIcon = (key: SortableKeys) => {
		if (sortConfig?.key === key) {
			if (sortConfig.direction === 'ascending') {
				return <img src={'/imgs/arrow_drop_up.png'} className={"img-clipboard"} alt="ascending"/>;
			}
			return <img src={'/imgs/arrow_drop_down.png'} className={"img-clipboard"} alt="descending"/>;
		}
		return null;
	}

	function handleRowClick(index: number) {
		setExpandedRows(currentExpanded => {
			if (currentExpanded.includes(index)) {
				// If already expanded, collapse it
				return currentExpanded.filter(i => i !== index);
			} else {
				// If collapsed, expand it
				return [...currentExpanded, index];
			}
		});
	}
	return (
		<div className="companies-page">
			<div className={"flex-row"}>
			<h3>Aziende ({companyList?.length || 0})</h3>
				<div style={{alignContent: "center"}}>
					<button className={"button"} style={{marginLeft: "10px"}} onClick={() => requestSort('latestOrderTime')}>
						{renderSortIcon('latestOrderTime')} Ultimo ordine
					</button>
					<button className={"button"} style={{marginLeft: "10px"}} onClick={() => requestSort('operators')}>
						{renderSortIcon('operators')} Numero operatori
					</button>
				</div>
			</div>
			<ul>
				{
					companyList.map((company: Company, index) => {
						const lastOrder = company.latestOrderTime ? moment(company.latestOrderTime).format(DATETIME_FORMAT_IT) : undefined
						const lastOrderNumber = company.documentNumber ? company.documentNumber : undefined
						const operatorsCount = company.operators?.length;
						const isExpanded = expandedRows.includes(index);

						return (
							<React.Fragment key={index}>
								<li className="company-row cursor-pointer" onClick={() => handleRowClick(index)}>
									<span className={"bold-text"}>{company.name}</span>
									{operatorsCount ? (" - " + operatorsCount + " operatori") : ""}
									{lastOrder ? (" - Ultimo ordine " + lastOrderNumber + " del " + lastOrder) : ""}
								</li>
								{isExpanded && company.operators && isNotEmptyArray(company.operators) && (
									<ul className="operators-sublist">
										{company.operators.map((operator, opIndex) => (
											<li key={opIndex} className="operator-item">{operator}</li>
										))}
									</ul>
								)}
							</React.Fragment>
						)
					})
				}
			</ul>
		</div>
	)
}
